var applicationPersonality = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationPersonalityCtrl ($scope, $sce, $timeout, userStore) {
        
        var ctrl = this;
        var message;
        ctrl.messages = [];

        function init () {
            ctrl.user = userStore.getUser();
        }

        function link () {
            $timeout(function() {
                if(!_.isEmpty(ctrl.user.smilies)) {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Du har udfyldt dette step før. Vælg 3 nye smileys der beskriver dig 😁'),
                        type: 'receive'
                    }); 
                } else {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Hey! Velkommen til! Vælg 3 smileys, der beskriver dig som person 😁'),
                        type: 'receive'
                    }); 
                }
                
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                // $timeout(function() {
                //     $location.path('/din-ansoegning');
                // }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user', 'personality'], onUserUpdated);

    },
    templateUrl: './angular/components/application-personality.component.html',
};